import axios from 'axios';
import { throttleAdapterEnhancer } from 'axios-extensions';

export const getThrottleAdapter = (delay = 5 * 1000) =>
  throttleAdapterEnhancer(axios.defaults.adapter!, {
    threshold: delay
  });
